
    <section class="content error mt-5">
      <div class="error__inner">
          <br />
          <br />
          <img src="./assets/img/error.gif" class="ml-4" style="height: 300px !important" />
          <h2 class="text-danger ml-4">The page you were looking for doesn`t exist!</h2>
          <p class="ml-4">Donec in ex eget orci facilisis gravida vitae ut tortor. In tempus lacus ac dui iaculis, placerat tempus diam vehiculaed
              suscipit tortor id lorem mollis</p>
      </div>